import { Table } from "../models/Table";

export class TableSearchResult {
    constructor(
        public tableId: string,
        public table: Table,
        public path: Array<number>,
        public topLevelParent: Table | undefined,
        public parent?: Table
    ) { }
}

export class TablesSearchService {

    public static findTableByIdRecursive(
        tables: Table[],
        targetId: string
    ): TableSearchResult | null {
        return this.search(tables, targetId);
    }

    private static search(
        tables: Table[],
        targetId: string,
        parent?: Table,
        topLevelParent?: Table,
        path: number[] = []
    ): TableSearchResult | null {
        for (let i = 0; i < tables.length; i++) {
            const table = tables[i];
            const currentPath = [...path, i];
            const currentTopLevel = topLevelParent ?? table;

            if (table.id === targetId) {
                return new TableSearchResult(targetId, table, currentPath, currentTopLevel, parent);
            }

            const nestedTables = table.configuration?.tables;
            if (Array.isArray(nestedTables)) {
                throw new Error("Tables containing child tables is not supported.");
                // const result = this.search(nestedTables, targetId, table, currentTopLevel, currentPath);
                // if (result) return result;
            }
        }

        return null;
    }

    public static setTableAtPath(
        topLevelParent: Table,
        path: number[],
        newTable: Table
    ): boolean {
        if (path.length === 0) return false; // Nothing to replace

        let currentTables = topLevelParent.configuration?.tables;
        if (!Array.isArray(currentTables)) return false;

        // Traverse to the parent of the target table
        for (let i = 0; i < path.length - 1; i++) {
            const index = path[i];
            const table = currentTables[index];
            if (!table?.configuration?.tables) return false;

            currentTables = table.configuration.tables;
        }

        const targetIndex = path[path.length - 1];

        // Replace the target table
        if (currentTables && currentTables[targetIndex]) {
            currentTables.splice(targetIndex, 1, newTable);
            return true;
        }

        return false;
    }
}
